import React from 'react'
import Helmet from 'react-helmet'

function jsonSameAs(json) {
  // data out of Drupal || seperated
  let sa_data = '';
  if(json !== undefined) {
    sa_data = json.split('||');
  }
  return sa_data;
}


function publisher(json) {
  let phpUnserialize = require('phpunserialize');
  let pubdata = phpUnserialize(json);
  // process sameas data
  pubdata.sameAs = jsonSameAs(pubdata.sameAs);
  return (pubdata);
}



function JsonSchema(props) {
  const sdata = props.json;

  // Everything goes in here eventually
  let schema_ld_graph = [];

  //
  // WEBSITE DATA
  let schema_web = {};

  // base website metadata - set in the gatsby-cofig.js file
  if(sdata.siteMetadata) {
    let siteMetadata = sdata.siteMetadata;

    // override defaults if set at a page level
    schema_web["@type"] = "WebSite"; // default
    if(sdata.schema_web_site_type) schema_web["@type"] = sdata.schema_web_site_type;
    schema_web.name = siteMetadata.title; // default
    if(sdata.schema_web_site_name) schema_web.name = sdata.schema_web_site_name;
    schema_web.url = siteMetadata.siteUrl; // default
    if(sdata.schema_web_site_url) schema_web.url = sdata.schema_web_site_url;

    if(sdata.schema_web_site_publisher){
      schema_web.publisher = publisher(sdata.schema_web_site_publisher);
    }

    // WEBSITE DATA :: end, push into main object
    schema_ld_graph.push(schema_web);
  }



  // example:
  // schema_ld_graph.push({
  //   "@type": "WebSite",
  //   "@id": "@organisation-id",
  //   "name": "The name of the web site.",
  //   "url": "The url of the web site.",
  //   "publisher": {
  //       "@type": "Organization",
  //       "@id": "@organisation-id",
  //       "name": "Org Name",
  //       "url": "Absolute URL of the canonical Web page",
  //       "sameAs": [
  //           "https://www.facebook1.com",
  //           "https://twitter.com",
  //           "https://www.linkedin.com",
  //           "https://www.youtube.com"
  //       ],
  //       "logo": {
  //           "@type": "ImageObject",
  //           "url": "Absolute URL of the image"
  //       }
  //   }
  // });

  // convert gatsby json data to valid schema-ld
  let schema_ld = {
    "@context": "https://schema.org",
    "@graph": schema_ld_graph
  }
  return (
    <Helmet>
    <script type="application/ld+json">{JSON.stringify(schema_ld, null, 2)}</script>
    </Helmet>
  )
}

export default JsonSchema


// fuller example
// {
//     "@context": "https://schema.org",
//     "@graph": [
//         {
//             "@type": "Article",
//             "headline": "REQUIRED BY GOOGLE. Headline of the article.",
//             "name": "Name (usually the headline of the article).",
//             "description": "RECOMMENDED BY GOOGLE. A description of the item.",
//             "datePublished": "2020-03-09",
//             "author": {
//                 "@type": "Organization",
//                 "@id": "@organization",
//                 "name": "Name of the organisation",
//                 "url": "Absolute URL of the canonical Web page",
//                 "sameAs": "facebook||twitter||linkedin"
//             },
//             "review": {
//                 "@type": "Review",
//                 "reviewBody": "The actual body of the review.",
//                 "datePublished": "datePublished",
//                 "author": {
//                     "@type": "Organization",
//                     "@id": "@organization-review",
//                     "name": "Review Name of the person or organization",
//                     "url": "Absolute URL of the canonical Web page",
//                     "sameAs": "facebook||twitter||linkedin"
//                 }
//             }
//         },
//         {
//             "@type": "Person",
//             "name": "The name of the person.",
//             "sameAs": "twitter||linkedin",
//             "url": "The URL for the person\u0027s official website.",
//             "description": "A description of the person.",
//             "email": "The email address of the person.",
//             "jobTitle": "The job title of the person",
//             "telephone": "The telephone number of the person",
//             "contactPoint": {
//                 "@type": "ContactPoint",
//                 "telephone": [
//                     "An internationalized version of the phone number"
//                 ],
//                 "url": [
//                     "URL of place",
//                     "organization"
//                 ],
//                 "contactType": "customer service"
//             }
//         },
//         {
//             "@type": "WebSite",
//             "name": "The name of the web site.",
//             "url": "The url of the web site.",
//             "publisher": {
//                 "@id": "@organisation",
//                 "name": "Org Name",
//                 "url": "Absolute URL of the canonical Web page",
//                 "sameAs": "facebook||twitter||linkedin"
//             }
//         }
//     ]
// }

